import * as React from 'react';
import { Text, Icon, Theming, ThemingContext } from '@doordash/design-language';
import { IconButton } from '@doordash/component-button';
import invariant from 'invariant';
import BannerActions from './BannerActions';
import { BannerWrapper, BannerContentWrapper, IconContainer } from './styles';
import { Variants, Types } from './types';
import { getIconType, bannerConfig } from './utils';

var Banner = function Banner(_ref) {
  var label = _ref.label,
      body = _ref.body,
      iconType = _ref.iconType,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? Types.Default : _ref$type,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? Variants.Informational : _ref$variant,
      _ref$isGlobal = _ref.isGlobal,
      isGlobal = _ref$isGlobal === void 0 ? false : _ref$isGlobal,
      onClose = _ref.onClose,
      _ref$closeButtonAcces = _ref.closeButtonAccessibilityLabel,
      closeButtonAccessibilityLabel = _ref$closeButtonAcces === void 0 ? 'Close' : _ref$closeButtonAcces,
      primaryAction = _ref.primaryAction,
      secondaryAction = _ref.secondaryAction;
  invariant(!body ? label : true, "You must include either a label or a body prop value");
  invariant(!!secondaryAction ? !!primaryAction : true, "You can only add a secondary Action if a primary action is first set");
  invariant(variant === Variants.Negative || variant === Variants.Warning ? !iconType : true, "Custom icons cannot be used for Banners with Negative or Warning variants");
  var currentTheme = React.useContext(ThemingContext);
  var showBannerActions = !!primaryAction || !!secondaryAction || !!onClose;
  var bannerColors = bannerConfig[variant][type];
  var bannerIconType = getIconType({
    variant: variant,
    type: type,
    iconType: iconType
  });
  return /*#__PURE__*/React.createElement(BannerWrapper, {
    variant: variant,
    type: type,
    isGlobal: isGlobal,
    hasCloseButton: !!onClose
  }, /*#__PURE__*/React.createElement(IconContainer, {
    variant: variant,
    type: type
  }, /*#__PURE__*/React.createElement(Icon, {
    color: Icon.Colors.CurrentColor,
    type: bannerIconType
  })), /*#__PURE__*/React.createElement(BannerContentWrapper, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    color: Text.Colors[bannerColors.foreground],
    styles: Text.Styles.BannerLabel
  }, label), typeof body === 'string' ? /*#__PURE__*/React.createElement(Text, {
    color: Text.Colors[bannerColors.foreground],
    styles: Text.Styles.BannerBody
  }, body) : body), showBannerActions && /*#__PURE__*/React.createElement(BannerActions, {
    variant: variant,
    type: type,
    primaryAction: primaryAction,
    secondaryAction: secondaryAction
  })), !!onClose && /*#__PURE__*/React.createElement(Theming, {
    overrides: {
      Colors: {
        ButtonFlatSecondaryForeground: currentTheme.Colors[bannerColors.foreground],
        ButtonFlatSecondaryForegroundHovered: currentTheme.Colors[bannerColors.foreground],
        ButtonFlatSecondaryForegroundPressed: currentTheme.Colors[bannerColors.foreground]
      }
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    accessibilityLabel: closeButtonAccessibilityLabel,
    iconType: IconButton.IconTypes.Close,
    size: IconButton.Sizes.Small,
    type: IconButton.Types.FlatSecondary,
    onClick: onClose
  })));
};

Banner.Types = Types;
Banner.Variants = Variants;
export default Banner;